<template>
  <div class="record-box" :style="{'display': display}">
    <table class="table-box">
      <tr v-for="item in resultData.records" :key="item.gid">
        <td>{{item.recordTime}}</td>
        <td>{{item.memorySize}}</td>
        <td>{{item.runTime}}</td>
        <td>{{item.codeCate}}</td>
        <td class="td-red">{{item.percentum}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import serviceApi from "@/utils/serviceApi";

export default {
  name: "recordPage",
  data(){
    return {
      resultData:{
        total: 0,
        records:[{
          gid: "01",
          recordTime: "2023-12-12 12:23:43",
          memorySize: "232kb",
          runTime: "23ms",
          codeCate: "Python",
          percentum: "23%"
          }]
      }
    }
  },
  props:{
    isShow: Boolean
  },
  watch:{
    "isShow":{
      handler(newVal, oldVal) {
        if(newVal && !oldVal){
          serviceApi.loadResult(this.callback);
        }
      },
      deep: false,
      immediate: true
    }
  },
  computed:{
    display:function (){
      if(this.isShow){
        return "block";
      }else{
        return "none";
      }
    }
  },
  mounted() {
    serviceApi.loadResult(this.callback);
  },
  methods:{
    callback: function (resultData){
      this.resultData = resultData;
      this.$emit('event-record', this.resultData.total)
    }
  }
}
</script>

<style scoped>
.record-box{
  width: calc(100% - 1px);
  height:calc(100% - 1px);
  background-color: #fff;
  color: #0a001f;
  overflow-y:auto;
}
.table-box{
  width:100%;
  border-collapse: collapse;
  font-size: 14px;
}
.table-box tr{
  height: 50px;
  text-align: center;
}
.table-box tr:hover{
  background-color: #eee;
}
.table-box td{
  width: 20%;
}
.td-red{
  color: red;
  font-weight: bold;
}
.td-green{
  color: green;
  font-weight: bold;
}
</style>
